import DefaultAvatar from "../assets/user.png";

export const DEFAULT_AVATAR = DefaultAvatar;

function getApiOrigin() {
  const apiPath = process.env.REACT_APP_API_PATH;

  if (!apiPath) return "";

  try {
    return new URL(apiPath).origin;
  } catch {
    return "";
  }
}

export function resolveAvatarUrl(pathOrUrl) {
  if (!pathOrUrl) return DEFAULT_AVATAR;

  if (/^https?:\/\//i.test(pathOrUrl)) {
    return pathOrUrl;
  }

  const origin = getApiOrigin();
  if (!origin) return pathOrUrl;

  return new URL(pathOrUrl, origin).toString();
}
